import { JSXElementConstructor, PropsWithChildren, ReactNode } from 'react';

/**
 * Component to wrap children with multiple providers
 */
interface Props {
    providers: JSXElementConstructor<PropsWithChildren>[];
    children: ReactNode;
}

export function WithProviders(props: Props) {
    const { providers = [], children } = props;

    return (
        <>
            {providers.reduceRight((acc, Provider) => {
                return <Provider>{acc}</Provider>;
            }, children)}
        </>
    );
}
